import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=17a9aad0"
import script from "./side-menu-item.vue?vue&type=script&lang=js"
export * from "./side-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a9aad0')) {
      api.createRecord('17a9aad0', component.options)
    } else {
      api.reload('17a9aad0', component.options)
    }
    module.hot.accept("./side-menu-item.vue?vue&type=template&id=17a9aad0", function () {
      api.rerender('17a9aad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/side-menu/side-menu-item.vue"
export default component.exports